module.exports = __webpack_public_path__ + "img/extron-logo.4f4f6a15.png";